<template>
  <div class="form user-form user-register-form">
    <div class="form-tabs">
      <!-- <div
        :class="{ active: type === 'email' }"
        @click="handleClickTabs('email')"
      >
        {{$t('使用邮箱')}}
      </div> -->
      <div
        :class="{ active: type === 'mobile' }"
        @click="handleClickTabs('mobile')"
      >
        {{$t('使用手机')}}
      </div>
    </div>
    <Email ref="email" v-show="type === 'email'"></Email>
    <Mobile ref="mobile" v-show="type === 'mobile'"></Mobile>
    <div class="text-error" v-show="errors" v-for="(error, key) in errors" :key="key">* {{error}}</div>
    <div class="actions">
      <SubmitButton class="btn btn-next" :valid="valid" :submit="handleRegister" :errors.sync="errors">
        {{$t('注册')}}
      </SubmitButton>
    </div>
    <div class="footer flex-row">
      <div class="text-muted" @click="handleAccecp">
        <i :class="['fa', accept ? 'fa-check-circle-o' : 'fa-circle-o']"></i>
        {{$t('用户隐私与使用协议')}}
      </div>
      <div class="flex1"></div>
      <div class="text-primary" @click="$emit('dest', 'login')">
        {{$t('登录')}}
      </div>
    </div>
  </div>
</template>

<script>
import Email from "./EmailRegister";
import Mobile from "./MobileRegister";
import apiUser from "@/api/user";
import SubmitButton from '../SubmitButton'

export default {
  name: "Register",
  components: { Email, Mobile, SubmitButton },
  data() {
    return {
      type: "mobile",
      childLoaded: false,
      accept: true,
      errors: [],
    };
  },
  computed: {
    valid() {
      return this.accept && this.childLoaded && this.$refs[this.type].valid;
    },
  },
  mounted() {
    this.childLoaded = true;
  },
  methods: {
    handleClickTabs(name) {
      this.type = name;
    },
    handleAccecp() {
      this.accept = !this.accept;
    },
    handleRegister() {
      let params = this.$refs[this.type].getFormData();
      return apiUser.register({ type: this.type, ...params }).then((res) => {
        this.$emit("register", res)
      });
    },
  },
};
</script>